import { render, staticRenderFns } from "./myTasks.vue?vue&type=template&id=23874039&"
import script from "./myTasks.vue?vue&type=script&lang=js&"
export * from "./myTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23874039')) {
      api.createRecord('23874039', component.options)
    } else {
      api.reload('23874039', component.options)
    }
    module.hot.accept("./myTasks.vue?vue&type=template&id=23874039&", function () {
      api.rerender('23874039', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/batchAddFriends/myTasks.vue"
export default component.exports